export function createMappingFromArray(array, property, source) {
  return array.reduce(
      (agg, userID) => {
        agg[userID] = source
          .filter((pv) => userID === pv.userID )
          .map((pv) => pv[property] ? pv[property] : null);
        return agg;
      },
      {}
    );
}

export function filterFromArray(array, property, source) {
  return array.reduce(
      (agg, val) => {
        agg[val] = source
          .filter((item) => val === item[property] );
        return agg;
      },
      {}
    );
}



// WEBPACK FOOTER //
// ./src/dataUtils.js